import { Component, Input, OnInit } from '@angular/core';
import { TableComponent } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/components/table/table.component';
import { IFilters } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/filters/filters.interface';
import { ITableDataSource } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table-data-source.interface';
import { ITablePagination } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-pagination.interface';
import { ITableSort } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table/table-sort.interface';
import { SessionService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/services/session.service';
import { IRecordingEvent } from '../../../tows/interface/recording-event.interface';
import { ITowLogEvent } from '../../../tows/interface/tow-log-event.interface';
import { TowLogApiService } from '../../services/tow-log-api.service';

@Component({
  selector: 'app-tow-log-table',
  templateUrl: './tow-log-table.component.html',
  styleUrls: ['./tow-log-table.component.scss'],
})
export class TowLogTableComponent extends TableComponent<ITowLogEvent, string> implements OnInit {
  readonly headings = ['eventDate', 'type', 'lat', 'long'];
  readonly widths = [10, 10, 10, 10, 10, 10, 10, 30];

  @Input() tow: IRecordingEvent<'tow'>;

  pageSize = 100;
  canSort = false;
  count: number;

  defaultSort: any = { active: 'eventDate', direction: 'asc' };

  constructor(
    sessionService: SessionService,
    readonly towLogEvents: TowLogApiService,
  ) {
    super(sessionService);
  }

  async ngOnInit() {
    await this.prepareTable(null);
  }

  ngAfterViewInit() {
    this.connectSubjects(null);
  }

  protected async getPaginated(
    filters: IFilters,
    sort: ITableSort,
    pagination: ITablePagination,
    search: string,
  ): Promise<ITableDataSource<ITowLogEvent>> {
    const result = await this.towLogEvents.getPaginated('', {
      filters,
      sort,
      pagination,
      search,
      simpleFilters: { towId: `ObjectId:${this.tow._id}` },
    });
    this.count = result.count;
    return result;
  }
}
